import React from "react";
//#region types
import { CurrencyEnums, TableEnums } from "models/enums";
import { StyledDateRange, StyledNumberRange } from "models/propTypes/commonPropTypes";
import { WintSuperkollAPIModel as ApiModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { SupplierRulesListProps } from "models/propTypes/supplierPropTypes";
//#endregion
//#region components
import { TableAsync, Tags } from "components/common";
import { useSupplierService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SupplierRulesList: React.FC<SupplierRulesListProps> = (props) => {
  const supplierService = useSupplierService();
  const { supplierId } = props;

  const filterFunc = React.useCallback(
    (baseFilter: WintUtilsWebApi.Filter) => supplierService.getRules(supplierId, baseFilter),
    []
  );

  const getDimensions = (list?: ApiModel.IncomingInvoiceRuleDimension[]): string[] => {
    return list
      ? list.map((m) => {
          return m.dimensionName ?? "";
        })
      : [];
  };

  const getStatus = (isActive: boolean): string => {
    return LocalizationHelperInstance.getFormattedMessage(
      isActive ? TranslationKeys.Common.Active : TranslationKeys.Common.InActive
    );
  };

  return (
    <TableAsync<ApiModel.IncomingInvoiceRule>
      properties={{
        maxAmount: {
          description: TranslationKeys.Common.Amount,
          formatter: (r: ApiModel.IncomingInvoiceRule) =>
            new StyledNumberRange(r.minAmount, r.maxAmount, CurrencyEnums.CurrencyCode.SEK),
          noWrap: true,
        },
        fromDate: {
          description: TranslationKeys.Common.Date,
          formatter: (r: ApiModel.IncomingInvoiceRule) => new StyledDateRange(r.fromDate, r.toDate),
          noWrap: true,
        },
        rulePeriod: {
          description: TranslationKeys.Common.Period,
          formatter: (r: ApiModel.IncomingInvoiceRule) => supplierService.getRulePeriodShortText(r.rulePeriod),
          noWrap: true,
        },
        dimensions: {
          description: TranslationKeys.Common.Dimensions,
          formatter: (r: ApiModel.IncomingInvoiceRule) => (
            <Tags tags={getDimensions(r.dimensions)} maxDisplayCount={2} />
          ),
          disableSort: true,
          maxWidth: 200,
        },
        bookingAccountName: {
          description: TranslationKeys.Common.ReferTo,
          noWrap: true,
        },
        active: {
          description: TranslationKeys.Common.Status,
          formatter: (r: ApiModel.IncomingInvoiceRule) => (
            <Tags tags={[getStatus(r.active)]} className={r.active ? cssExports.greenTag : cssExports.yellowTag} />
          ),
        },
      }}
      filter={filterFunc}
      pagination={"advanced"}
      maxRowCount={10}
      hidePaginationIfSinglePage
      tableId={TableEnums.TableType.SupplierRulesList}
    />
  );
};
export default SupplierRulesList;
